import { MegaphoneIcon } from "@heroicons/react/24/outline";
import { SidebarItem, SidebarLabel } from "components/layout/sidebar";
import { Badge } from "components/ui/badge";
import React, { useCallback, useEffect, useRef, useState } from "react";
import {
    getUnseenCount,
    initializeSidebarUpdates,
    initializeUpdates,
} from "util/updates";

export const UpdatesIcon: React.FC<unknown> = () => {
    useEffect(() => {
        initializeUpdates();
    }, []);

    return (
        <div className="relative">
            <MegaphoneIcon className="h-6 w-6 rounded-full text-gray-600 hover:text-gray-900" />
            <div id="product-updates" className="absolute top-0 left-0" />
        </div>
    );
};

export const AnnouncementsSidebarItem: React.FC<unknown> = () => {
    const [unseenCount, setUnseenCount] = useState(0);
    const intervalRef = useRef<NodeJS.Timeout>();

    const checkUnseenCount = useCallback(() => {
        const count = getUnseenCount();
        setUnseenCount(count);
    }, []);

    useEffect(() => {
        initializeSidebarUpdates();

        const initialCheckTimeout = setTimeout(() => {
            checkUnseenCount();
            intervalRef.current = setInterval(checkUnseenCount, 10000);
        }, 3000);

        return () => {
            clearTimeout(initialCheckTimeout);
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [checkUnseenCount]);

    return (
        <SidebarItem id="sidebar-announcements-trigger" className="relative">
            <MegaphoneIcon />
            <SidebarLabel className="flex-1">
                <div className="flex justify-between items-center w-full">
                    <div>Announcements</div>
                    {unseenCount > 0 ? (
                        <Badge
                            important
                            value={unseenCount.toString()}
                            type="highlight"
                        />
                    ) : null}
                </div>
            </SidebarLabel>
            <div
                id="sidebar-product-updates-badge"
                className="absolute top-2 left-4 opacity-0 pointer-events-none"
            />
        </SidebarItem>
    );
};
